import { useState } from 'react'
import useTranslation from '@/hooks/useTranslation'
import usePageTitle from '@/hooks/usePageTitle'
import BalticLogo from '@/components/BalticLogo'
import WarrantyForm from '@/components/WarrantyForm'
import WarrantySuccess from '@/components/WarrantySuccess'

function WarrantyAssociation() {
    const { t } = useTranslation()
    usePageTitle(t('nav.warranty'))
    const [successData, setSuccessData] = useState(null)

    return (
        <div className="flex relative min-h-screen">
            {successData ? (
                <div className="flex-1 min-h-screen px-[24px] lg:pl-[48px] lg:pr-[160px] py-[100px] lg:py-[172px] flex flex-col justify-center items-center">
                    <div className="max-w-[630px] w-full">
                        <WarrantySuccess
                            data={successData}
                            onAssociateMore={() => setSuccessData(null)}
                        />
                    </div>
                </div>
            ) : (
                <div className="h-full flex-1 px-[24px] lg:pl-[48px] lg:pr-[160px] py-[100px] lg:py-[172px]">
                    <WarrantyForm onSubmit={setSuccessData} />
                </div>
            )}

            <div className="w-[41.66%] hidden xl:flex items-center justify-center bg-background-product px-[107px] h-full sticky top-0 bottom-0 right-0 h-screen">
                <div style={{
                    width: '386px',
                    height: '243px',
                    background: '#000000',
                    boxShadow: '4px 8px 12px rgba(0, 0, 0, 0.2)',
                    borderRadius: '24px',
                    position: 'relative',
                    overflow: 'hidden',
                    flexShrink: 0,
                }}>
                    {/* Baltic logo centered */}
                    <div style={{ position: 'absolute', left: 'calc(50% - 64.5px)', top: 'calc(50% - 12px)' }}>
                        <BalticLogo size={24} color="white" />
                    </div>

                    {/* Bottom text */}
                    <div style={{
                        position: 'absolute',
                        width: '182px',
                        left: 'calc(50% - 91px + 0.5px)',
                        top: '195.5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '4px',
                    }}>
                        <span style={{ fontFamily: 'Proxima Nova, sans-serif', fontSize: '14px', fontWeight: 400, lineHeight: 1, textTransform: 'uppercase', color: '#FFFFFF', whiteSpace: 'nowrap' }}>
                            International Warranty
                        </span>
                        <span style={{ fontFamily: 'Proxima Nova, sans-serif', fontSize: '14px', fontWeight: 400, lineHeight: 1, textTransform: 'uppercase', color: '#FFFFFF', whiteSpace: 'nowrap' }}>
                            Garantie Internationale
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WarrantyAssociation
